import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants" as const;

export const postDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsCacheKeys: AllRouteEndpoints[] =
  [
    decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants,
    decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents,
  ];
